import React, { FC } from 'react';
import Modal from '@components/Modal';
import Button from '@/components/DesignLibrary/Button';
import WarningCircle from '@/components/Icons/WarningCircle';
import s from './UploadBankStatementModal.module.scss';

type Props = {
  setInvalidDocModalOpen: (open: boolean) => void;
};

const SizeErrorModal: FC<Props> = ({ setInvalidDocModalOpen }) => (
  <Modal hasPadding onClose={() => setInvalidDocModalOpen(false)} title="">
    <div className={s.modalHeader}>
      <WarningCircle size={96} weight="fill" color="var(--color-warning)" />
      <h2 className="body-lg-bold">File size too large</h2>
      <p className={[s.modalBodyText, s.modalTextWarning].join(' ')}>
        Maximum allowed file size is 5MB, consider compressing your file or choose another file below 5MB !
      </p>
    </div>
    <div className={s.modalBody}>
      <div className={s.modalBodyButtons}>
        <Button
          size="md"
          className={s.modalBodyButton}
          variant="primary"
          onClick={() => {
            setInvalidDocModalOpen(false);
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  </Modal>
);

export default SizeErrorModal;
